// CONSTANTS are all caps.
const NS = "RacCalculatorBlock";
const CLS = "racCalculatorBlock";
const BLK = "." + CLS + "-";
import "select2";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class RacCalculatorBlock {
	constructor(el) {
		// $el is the blk node return by the loadRacCalculatorBlock function
		this.$el = $(el);
		this.maxRad = 0;
		this.dapSliderValue = 0;
		this.radValue = 0;
		this.roomTypeMaxRadDropDown = this.$el.find(`#RoomTypeMaxRad`);
		this.dapSlider = this.$el.find(`#dap-slider`);
		this.dapSliderContainer = this.$el.find(`#dap-slider-container`);
		this.interestRate = +this.$el.data("curreninterestrate");
		this.pageId = this.$el.data("pageid");
		this.calculatorhiddenid = this.$el.data("calculatorhiddenid");

		this.radInput = this.$el.find(`#rad-input`);
		this.radTextContainer = this.$el.find(`.rad-amount`);
		this.dapTextContainer = this.$el.find(`.dap-amount`);
		this.roomTypeHelp = this.$el.find(`.room-type-help`);
		this.radContainer = this.$el.find(`.calculator-container-row-rad`);
		this.resultsContainer = this.$el.find(
			`.calculator-container-row-result`
		);
		this.interestRatePlaceholder = this.$el.find(
			`.interest-rate-placeholder`
		);
		this.emailEstimate = this.$el.find(`#email-estimate`);
		this.emailEstimate = this.$el.find(`#email-estimate`);
		this.formCalculatorField = this.$el.find(
			`[name="${this.calculatorhiddenid}"]`
		);
		this.formContainer = this.$el.find(`.racCalculatorBlock-form`);
	}

	init() {
		this.interestRatePlaceholder.text(this.interestRate);
		this.setRacCalculatorBlock();
		this.initSelect2();
		const that = this;
		this.roomTypeMaxRadDropDown.on("change", function (e) {
			debugger;
			that.selectedRoom = $(this).find(":selected").attr("data-id");

			that.dapSlider.prop("disabled", false);
			that.roomTypeHelp.removeClass("d-none");
			that.roomTypeHelp.addClass("d-block");
			that.radContainer.removeClass("calculator-container-row-disabled");
			if (e.currentTarget && e.currentTarget.value) {
				that.roomTypeHelp.text("Room cost: " + e.currentTarget.value);
				that.maxRad = +e.currentTarget.value
					.replace(",", "")
					.replace("$", "");
				if (that.radValue) {
					let val = (that.radValue / that.maxRad) * 100;
					if (val >= 100) {
						val = 100;
						that.radValue = that.maxRad;
						that.radInput.val(
							`$${that.maxRad.toLocaleString("en")}`
						);
					}

					that.dapSlider.val(val);
					// .trigger("change");
					that.dapSliderValue = val;
					that.dapSliderContainer
						.get(0)
						.style.setProperty("--value", `${+val}`);
				}
				that.updateValues();
			}
		});

		this.radInput.on("input", function (e) {
			if (e.currentTarget && e.currentTarget.value) {
				const currentRad = +e.currentTarget.value
					.replace(",", "")
					.replace("$", "");
				if (isNaN(currentRad)) {
					return;
				}
				that.resultsContainer.removeClass(
					"calculator-container-row-disabled"
				);
				that.radValue = currentRad;
				let val = (that.radValue / that.maxRad) * 100;

				if (val >= 100) {
					val = 100;
					that.radValue = that.maxRad;
				}
				that.dapSlider.val(val);
				// .trigger("change");
				that.dapSliderValue = val;
				that.dapSliderContainer
					.get(0)
					.style.setProperty("--value", `${+val}`);
				that.radInput.val(`$${that.radValue.toLocaleString("en")}`);

				that.updateValues();
			}
		});

		this.dapSlider.on("input", function (e) {
			if (e.currentTarget && e.currentTarget.value) {
				that.dapSliderValue = +e.currentTarget.value;
				that.radValue = Math.round(
					(that.dapSliderValue / 100) * that.maxRad
				);
				that.radInput.val(
					`$${Math.round(
						(that.dapSliderValue / 100) * that.maxRad
					).toLocaleString("en")}`
				);

				that.updateValues();
			}
		});

		this.emailEstimate.on("click", function (e) {
			that.formCalculatorField.val(
				`${that.pageId}*${that.selectedRoom}*${that.radValue}*${that.dapValue}`
			);
			that.formContainer.show();
			that.emailEstimate.hide();
		});
	}

	updateValues() {
		// debugger
		const interestRate = this.interestRate / 100.0;
		const maxRad = this.maxRad;
		const slidervalue = this.dapSliderValue;
		const radValue = (slidervalue / 100.0) * maxRad;
		const dapValue = ((maxRad - radValue) * interestRate) / 365.0;
		this.dapValue = dapValue;
		this.updateRadDapText(Math.round(radValue), dapValue.toFixed(2));
	}

	updateRadDapText(rad, dap) {
		this.radTextContainer.text("$" + rad.toLocaleString("en"));
		this.dapTextContainer.text("$" + dap.toLocaleString("en") + " / day");
	}

	setRacCalculatorBlock() {
		// Add Some logic here
	}

	initSelect2() {
		this.roomTypeMaxRadDropDown.select2({
			// theme: 'bootstrap4',
			width: "100%",
			minimumResultsForSearch: -1,
			placeholder: "Select room",
		});
	}

	// Add more functions like on above here
}
